import React from 'react';
import styles from './Footer.module.css';
import xingIcon from '../../images/xing-logo.png';
import linkedInIcon from '../../images/linkedin.png';

const Footer = () => {
  return (
    <div className={styles.footer}>
      <div className={styles.socialLinksWrapper}>
        <a href="https://www.xing.com/profile/Marco_Tissen039848/web_profiles" target="_blank" rel="noopener noreferrer" className={styles.socialIconLink}>
          <img src={xingIcon} loading="lazy" alt="Xing Icon" />
        </a>
        <a href="https://www.linkedin.com/in/marco-tissen-a97b43347/" target="_blank" rel="noopener noreferrer" className={styles.socialIconLink}>
          <img src={linkedInIcon} loading="lazy" alt="LinkedIn Icon" />
        </a>
      </div>
      <div className={styles.caption}>
        Copyright © {new Date().getFullYear()} Marco Tissen. All rights reserved.
      </div>
    </div>
  );
};

export default Footer; 